import React from 'react'

import { ICustomFieldFormSetting } from '@user/store/entityFormSettings'
import Box from '@mui/material/Box'
import {
  useDragData,
  DraggableItemWrapper,
  DropResult,
} from '@user/utils/Draggable'
import { CustomSettingsDraggableCard } from './CustomSettingsDraggableCard'

type Props = {
  settings: ICustomFieldFormSetting[]
  updateSettings: (settings: ICustomFieldFormSetting[]) => void
}

export function CustomSettingsList(props: Props) {
  const { settings, updateSettings } = props

  const { containerRef, itemRefs, draggingIndex, offsets } = useDragData({
    dataList: settings,
    onDragEnd: (result: DropResult) => {
      const dropped = settings[result.sourceIndex]
      const newSettings = [...settings]
      newSettings.splice(result.sourceIndex, 1)
      newSettings.splice(result.destinationIndex, 0, dropped)

      const update = newSettings.map((s, i) => ({
        ...s,
        order: i,
      }))

      updateSettings(update)
    },
  })

  return (
    <Box ref={containerRef} id="customSettings">
      {settings.map((row, i) => (
        <DraggableItemWrapper
          key={row.customFieldId}
          ref={(el) => (itemRefs.current[i] = el as HTMLDivElement | null)}
          draggingIndex={draggingIndex}
          index={i}
          offsets={offsets}
        >
          <CustomSettingsDraggableCard setting={row} />
        </DraggableItemWrapper>
      ))}
    </Box>
  )
}
